"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageListRight = exports.PageListPaging = exports.PageListPageNumber = exports.PageListLeft = exports.PageListHeading = exports.PageListControls = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = require("@kyruus/button");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.PageListControls = styled_1.default.div `
  max-width: 250px;
  display: flex;
  justify-content: space-between;
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.PageListHeading = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  text-align: center;
`;
exports.PageListLeft = (0, styled_1.default)(button_1.ButtonWithIcon) `
  & > span > span:last-of-type {
    margin-left: 0px;
    margin-right: 0px;
  }
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0 0;
`;
exports.PageListPageNumber = styled_1.default.div `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
  display: flex;
  align-items: center;
  letter-spacing: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
exports.PageListPaging = styled_1.default.nav `
  display: flex;
  flex: 0 1 auto;
`;
exports.PageListRight = (0, styled_1.default)(button_1.ButtonWithIcon) `
  & > span > span:last-of-type {
    margin-left: 0px;
    margin-right: 0px;
  }
  padding: 0 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
//# sourceMappingURL=MiniProviderPageList.styles.js.map